<template>
  <v-row>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      persistent
      transition="dialog-bottom-transition"
    >
      <v-card class="elevation-0 rounded-0 fill-height">
        <v-toolbar
            dark
            class="noprint modal-header-gradient"
            >
            <v-btn
                icon
                class="modal-close-btn"
                @click="dialog= false"
            >
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title class="font-weight-bold">
                <v-icon left>mdi-clipboard-text-outline</v-icon>
                Student Scores Entries
            </v-toolbar-title>
        </v-toolbar>
        <v-stepper v-model="e1" flat>
            <v-stepper-header>
            <v-stepper-step
                :complete="e1 > 1"
                step="1"
            >
                Fetch Records
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step
                :complete="e1 > 2"
                step="2"
            >
                Update Record
            </v-stepper-step>

            <v-divider></v-divider>

            <v-stepper-step step="3">
                Preview
            </v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
            <v-stepper-content step="1">
                <v-card
                flat
                class="mb-8 pa-4"
                color="#fff"
                >
                    <!-- Search Form -->
                    <find-score-record :classes="classes" :terms="terms" :authToken="authToken" :accessToken="accessToken" :school="school" @students="studentRecords" @subjects="subjectRecords" @parameterId="selectedTerm" @clasxId="selectedClass" @subjectId="selectedSubject"/>

                </v-card>

                <v-btn
                :disabled="!fetchF"
                color="primary"
                rounded
                elevation="2"
                class="px-6"
                @click="step2"
                >
                Continue
                <v-icon right>mdi-arrow-right</v-icon>
                </v-btn>

                <v-btn outlined rounded class="ml-2" @click="dialog = false">
                Close
                </v-btn>
            </v-stepper-content>

            <v-stepper-content step="2">
                <v-card
                v-if="records"
                flat
                class="mb-8 pa-4"
                color="#fff"
                >
                    <v-card-title>{{records.subject}}</v-card-title>
                    <v-card-subtitle class="caption">Showing student scores for Subject: <strong>{{records.subject}}</strong> for Class: <strong>{{records.class.name}}</strong> for the <strong>{{records.term.session}} {{records.term.name}}</strong> Term Academic Session</v-card-subtitle>
                    <v-alert border="left" color="blue" dismissible type="info" text>
                        Leave scores blank for students that do not offer the subject
                    </v-alert>

                    <score-entry v-if="reRenderComponent" :authToken="authToken" :accessToken="accessToken" :students="students" :school="school" :term="parameter_id" :clasx="clasx_id" :subject="subject_id" @updatedScoreRecords="updatedScores"/>

                </v-card>

                <v-btn
                color="primary"
                rounded
                elevation="2"
                class="px-6"
                @click="step3"
                >
                <v-icon left>mdi-content-save</v-icon>
                Save
                </v-btn>

                <v-btn outlined rounded class="ml-2" @click="e1 = 1">
                    <v-icon left>mdi-chevron-double-left</v-icon>
                    Back
                </v-btn>
            </v-stepper-content>

            <v-stepper-content step="3">
                <v-card
                v-if="records"
                flat
                class="mb-8 pa-4"
                color="#f5f5f5"
                >
                    <v-card-title>Crosscheck {{records.subject}} Scores</v-card-title>
                    <v-alert border="left" color="orange" dismissible type="info" text>
                        To enter scores for Students with no scores, <strong>refresh page</strong> and re-enter scores
                    </v-alert>
                    <score-preview :records="records" :authToken="authToken" :accessToken="accessToken" :students="students" :school="school"/>
                </v-card>

                <v-btn
                color="primary"
                rounded
                elevation="2"
                class="px-6"
                @click="dialog = false"
                >
                Close
                </v-btn>

                <v-btn outlined rounded class="ml-2" @click="e1 = 2">
                <v-icon left>mdi-chevron-double-left</v-icon>
                Back
                </v-btn>

                <v-btn outlined rounded class="ml-2" @click="e1 = 1">
                <v-icon left>mdi-refresh</v-icon>
                New Entry
                </v-btn>
                <v-card-subtitle v-if="school.plan === 'Free'" class="caption">Schools on Premium Plan can do much more!</v-card-subtitle>
            </v-stepper-content>
            </v-stepper-items>
        </v-stepper>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from 'axios';
import ScoreEntry from './ScoreEntry.vue';
import FindScoreRecord from './FindScoreRecord.vue';
import ScorePreview from './ScorePreview.vue';
    export default {
    components: { ScoreEntry, FindScoreRecord, ScorePreview },
        name: 'SubjectScoresModal',
        props:[
            'authToken', 
            'accessToken', 
            'school',
            'terms',
            'classes',
        ],
        data () {
            return {
                e1: 1,
                dialog: true,
                records: null,
                fetchF:false,
                storeF:true,
                students:null,
                subjects:null,
                parameter_id:null,
                subject_id:null,
                clasx_id:null,
                student_ids:null,
                scoreData:{
                    scores: null
                },
                reRenderComponent:true
            }
        },
        computed:{
           //
        },
        methods: {
            fetchScores (){
                let loader = this.$loading.show()
                axios.get(process.env.VUE_APP_BASEURL+'/broadsheets?school_id='+this.school.school_id+'&clasx_id='+this.clasx_id+'&parameter_id='+this.parameter_id+'&subject_id='+this.subject_id+'&group_by=subjects',
                {
                    headers: 
                    {
                        'Authorization': 'Bearer '+this.authToken,
                        'X-Access-Token': this.accessToken,
                    }
                })
                .then((response) => {
                    this.records =  response.data.data         
                })
                .catch((error) => {
                    this.$toast.error(error.response ? error.response.data.message : 'Network Error, Please try again few minutes', {
                        timeout: 5000
                    });
                })
                .finally(() => {
                    loader.hide()
                });
            },
            updateScores (){
                if(confirm("Students with total scores of 0 will not be saved. Are you sure you want to continue?")){
                    let loader = this.$loading.show()
                    axios.post(process.env.VUE_APP_BASEURL+'/scores?school_id='+this.school.school_id+'&clasx_id='+this.clasx_id+'&parameter_id='+this.parameter_id+'&subject_id='+this.subject_id,this.scoreData,
                    {
                        headers: 
                        {
                            'Authorization': 'Bearer '+this.authToken,
                            'X-Access-Token': this.accessToken,
                        }
                    })
                    .then((response) => {
                        console.log(response.data.success)
                        this.fetchScores()         
                    })
                    .catch((error) => {
                        this.$toast.error(error.response ? error.response.data.message : 'Network Error, Please try again few minutes', {
                            timeout: 5000
                        });
                    })
                    .finally(() => {
                        loader.hide()
                    });
                }
            },
            studentRecords (value){
                this.students = value
            },
            subjectRecords (value){
                this.subjects = value
                this.fetchF = true
            },
            selectedTerm (value){
                this.parameter_id = value
            },
            selectedClass (value){
                this.clasx_id = value
            },
            selectedSubject (value){
                this.subject_id = value
            },
            updatedScores (value){
                this.scoreData.scores = value
            },
            step2 (){
                this.reRenderComponent = false;
                this.$nextTick(() => {
                // Add the component back in
                this.reRenderComponent = true;
                });
                this.fetchScores()
                this.e1 = 2
            },
            step3 (){
                this.updateScores()
                this.e1 = 3
            }
        }
  }
</script>

<style scoped>

</style>